import { useDropzone } from 'react-dropzone';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import Notify from '@/components/Notification';
import Icon from './assets/upload-cloud.svg?react';
import { FilePreview } from './file';
import { buildAccept } from './utils';
import s from './index.module.scss';

export const UploadField = ({ name, value, onChange, error, allowedTypes, allowedSize }) => {
  const { t } = useTranslation('compliance');
  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop: acceptedFiles => {
      onChange([...value, ...acceptedFiles]);
    },
    multiple: true,
    accept: buildAccept(allowedTypes),
    maxSize: allowedSize,
    onDropRejected: fileRejections => {
      fileRejections.forEach(rejection => {
        rejection.errors.forEach(error => {
          if (error.code === 'file-too-large') {
            Notify.error({
              text: t('upload_field.file_too_large', { fileName: rejection.file.name }),
            });
          } else if (error.code === 'file-invalid-type') {
            Notify.error({
              text: t('upload_field.invalid_file_type', { fileName: rejection.file.name }),
            });
          }
        });
      });
    },
  });

  const onRemove = indexToRemove => {
    const updatedFiles = value.filter((_, index) => index !== indexToRemove);
    onChange(updatedFiles);
  };

  return (
    <div className={s.wrapper}>
      <div
        className={classnames(s.dropzone, error && s.dropzone_error)}
        {...getRootProps()}
      >
        <input {...getInputProps()} name={name} />
        <div className={s.dropzone_inner}>
          <div className={s.icon_wrapper}>
            <Icon className={classnames(s.icon, error && s.icon_error)} />
          </div>
          {isDragActive ? (
            <p className="f-body-regular">{t('upload_field.drag_active')}</p>
          ) : (
            <p className="f-body-regular">
              {t('upload_field.drag_inactive_prefix')}{' '}
              <span className="f-body-accent">{t('upload_field.browse')}</span>
            </p>
          )}
          <div className={classnames(s.desc, 'f-small-regular')}>
            {t('upload_field.hint')}
          </div>
        </div>
      </div>
      {error && (
        <div className={classnames(s.error, 'f-small-regular')}>{error}</div>
      )}
      {value && value.length > 0 && (
        <div className={s.files}>
          {value.map((file, index) => (
            <FilePreview
              key={index}
              name={file.name}
              size={file.size}
              onRemove={() => onRemove(index)}
            />
          ))}
        </div>
      )}
    </div>
  );
};
